<section class="plan-wrapper">
  <div class="container">
    <ul class="subscription-list">
      <li class="subs-wrap">
        <div class="subs-content customPlan active">
          <h2 [ngStyle]="{'text-align':'center'}">Select your plan below to start the 30 day free trial
          </h2>
          <ul class="plan-switch d-flex">
            <li [ngClass]="{'active':showMonthlyPlan}" (click)="showPlanDefault('monthly')" id="monthly">
              <h2>Monthly</h2>
            </li>
            <li [ngClass]="{'active':showYearPlan}" (click)="showPlanDefault('yearly')" id="yearly">
              <h2>Annually</h2>
            </li>
          </ul>
          <ng-container *ngIf="getPlanData">
            <ul class="plan-list d-flex justify-content-between flex-wrap">
              <ngx-slick-carousel class="carousel" #slickModal [config]="slideConfig">
                <li ngxSlickItem class="slide subscription-box" (click)="chnageCard($event,'plan',i,getData,0)"
                  *ngFor="let getData of getPlanData;let i=index;let first = first"
                  [ngClass]="{'effect':((selectedcard['plan'] && selectedcard['plan']['currentPlan']!==''))?(i==selectedcard['plan']['currentPlan']):false}">
                  <div class="plan-data">
                    <span class="pricecard-tag" *ngIf=" (currentSelectionType=='yearly' && i==1)">
                      <img src="assets/images/plancard-tag-bg.png" alt="img">
                      <span class="txt">Recommended</span>
                    </span>
                    <h3>{{getData['name']}}<span style="display:block;">{{getData['name'] === 'Free'? ''
                        :getData['aliasname']}}</span></h3>
                    <div *ngIf="(+(getData['planDurationObject']['price'])==0)"
                      class="price-wrap d-flex align-items-end flex-wrap"><strong>FREE</strong></div>
                    <div *ngIf="(+(getData['planDurationObject']['price'])!=0)"
                      class="price-wrap d-flex align-items-end flex-wrap">
                      <del
                        *ngIf="(+(getData['planDurationObject']['price'])!=getData['planDurationObject']['price']-((getData['planDurationObject']['price']/100)* +(getData['shopDiscount'])))">{{+(getData['planDurationObject']['price'])
                        | currency:'USD':'symbol':'1.0-0'}} {{(currentSelectionType=='monthly')?'/ mo':'/ yr' }}</del>
                      <strong
                        *ngIf="currentSelectionType=='monthly'">{{getData['planDurationObject']['price']-((getData['planDurationObject']['price']/100)*
                        +(getData['shopDiscount'])) | currency:'USD'}}<sub>/ mo</sub></strong>
                      <strong
                        *ngIf="(currentSelectionType=='yearly')">{{(getData['planDurationObject']['price']-((getData['planDurationObject']['price']/100)*
                        +(getData['shopDiscount'])))/12 | currency:'USD'}}<sub>/ mo</sub>
                      </strong>
                      <span class="save-price" [ngStyle]="{'margin-left':'27px'}"
                        *ngIf="(currentSelectionType=='yearly')">{{(getData['planDurationObject']['price']-((getData['planDurationObject']['price']/100)*
                        +(getData['shopDiscount'])))| currency:'USD'}} paid annually</span>
                      <ng-container *ngIf="(currentSelectionType=='yearly')">
                        <ng-container *ngFor="let m of monthData">
                          <span class="save-price" *ngIf="m['key']==getData['name']">{{'('+' '+'You'+' '+'Save'+'
                            '+getamount(m['total'],getData['planDurationObject']['price'])+'%'+' '+')'}}</span>
                        </ng-container>
                      </ng-container>
                    </div>
                    <a class="btn">{{( getData['isCurrentPlan'])?(+(getData['planDurationObject']['price'])==0)?'Start
                      Now':'Start With Current Plan':((getData['isTrial']!=0 && getData['noOfDay']!=0 &&
                      getData['isTrialUsed']==0)? (getData['noOfDay'])+' '+'Days FREE Trial' :'Subscribe Now')}}</a>
                    <ul class="benefits-points">
                      <li *ngFor="let det of getData['details']" [ngClass]="{'low-visible':!+(det['inPlan'])}">
                        {{det['sub_detail']}}
                      </li>
                    </ul>
                    <label class="checkbox-plan">
                      <strong type="radio" name="cardtype" id="plan-checkbox{{i}}">
                      </strong>
                    </label>
                  </div>
                </li>
              </ngx-slick-carousel>
            </ul>
          </ng-container>
        </div>

      </li>
      <ng-container *ngIf="false">
        <li class="subs-wrap" *ngFor="let planName of customPlanData;let j=index">
          <div class="plan-head" (click)="accordianPlanChange($event,j+1)">
            <span class="circle-number">{{j+2}}</span>
            <h1>{{planName['name']}}</h1>
            <a>
              <i class="icon-arrow"></i>
            </a>
          </div>

          <div class="subs-content customPlan">
            <p *ngIf="((planName['name'])=='Wellness Coach')">If you need more support and accountability, add on the
              services of our Wellness Coach for a personalized plan to get you back on track. Our team of Health,
              Wellness and Life Coaches collaborate to provide you with a more holistic
              approach to helping you with each aspect of your wellness journey.
              <br />
              Enroll now and get a 14-day free trial with our wellness coaches!
            </p>
            <p *ngIf="((planName['name'])=='Travel Advisor')">If you don’t have the time to plan or are overwhelmed by
              the choices,  let our Wellness Travel Advisor handle all the details and customize your next getaway so
              you can just sit back and enjoy the journey. Book now and enjoy 20% off on our travel advisor services!
              <br />
            </p>
            <ng-container *ngIf="planName['subsPlans']">
              <ul class="plan-list d-flex justify-content-between flex-wrap">
                <ngx-slick-carousel class="carousel" #slickModal [config]="slideConfig">
                  <li ngxSlickItem class="slide subscription-box"
                    (click)="chnageCard($event,planName['name'],i,getData,j+1)"
                    *ngFor="let getData of planName['subsPlans'];let i=index;let first = first"
                    [ngClass]="{'effect':((selectedcard[planName['name']] && selectedcard[planName['name']]['currentPlan']!==''))?(i==selectedcard[planName['name']]['currentPlan']):false}">
                    <div class="plan-data">
                      <h3>{{getData['name']}} <span style="display:block;">{{getData['name'] === 'Free'? ''
                          :getData['aliasname']}}</span></h3>

                      <div class="price-wrap d-flex align-items-end flex-wrap">
                        <del
                          *ngIf="(+(getData['planprice'])!=(getData['planprice']-((getData['planprice']/100)* +((getData['shopDiscount']!=='')?getData['shopDiscount']:0))))">{{(+(getData['planprice'])*(getData['plandur']))
                          | currency:'USD':'symbol':'1.2-2'}} /
                          {{(getData['durtype']=='year')?'yr':(getData['durtype']=='month')?'mo':(getData['durtype']=='day')?'d':(getData['durtype']=='week')?'w':''}}</del>
                        <strong
                          *ngIf="((planName['name'])=='Wellness Coach')">{{((getData['planprice']-((getData['planprice']/100)*
                          +((getData['shopDiscount']!=='')?getData['shopDiscount']:0)))) |
                          currency:'USD':'symbol':'1.2-2'}}<sub>/ Week</sub></strong>

                        <span class="save-price"
                          *ngIf="((planName['name'])=='Wellness Coach')">({{((getData['planprice']-((getData['planprice']/100)*
                          +((getData['shopDiscount']!=='')?getData['shopDiscount']:0))))*(getData['plandur']) |
                          currency:'USD':'symbol':'1.2-2'}} one time payment )</span>

                        <strong
                          *ngIf="((planName['name'])=='Travel Advisor')">{{getData['planprice']-((getData['planprice']/100)*
                          +((getData['shopDiscount']!=='')?getData['shopDiscount']:0)) | currency:'USD'}}<sub>/
                            {{(getData['durtype']=='year')?'yr':(getData['durtype']=='month')?'mo':(getData['durtype']=='day')?'d':(getData['durtype']=='week')?'w':''}}</sub></strong>
                      </div>

                      <a *ngIf="((planName['name'])=='Wellness Coach')" class="btn">{{( getData['isCurrentPlan'])?'Start
                        With Current Plan':((getData['isTrial']!=0 && getData['noOfDay']!=0 &&
                        getData['isTrialUsed']==0)?(getData['noOfDay']+' Days FREE Trial') :'Select Card')}}</a>

                      <a *ngIf="((planName['name'])=='Travel Advisor') && getData['shopDiscount'] && getData['shopDiscount']>0"
                        class="btn">{{( getData['isCurrentPlan'])?'Start With Current Plan':((getData['isTrial']!=0 &&
                        getData['noOfDay']!=0 && getData['isTrialUsed']==0)?(getData['noOfDay']+' Days FREE Trial')
                        :(getData['shopDiscount']?getData['shopDiscount']+''+'% Off':0+''+'% Off'))}}</a>
                      <ul class="benefits-points">
                        <li *ngFor="let det of getData['details']" [ngClass]="{'low-visible':!+(det['inPlan'])}">
                          {{det['sub_detail']}}
                        </li>
                      </ul>
                      <label class="checkbox-plan">
                        <strong type="radio" name="cardtype" id="plan-checkbox{{i}}">
                          <span class="plan-checkbox"></span>
                        </strong>
                      </label>
                    </div>
                  </li>
                </ngx-slick-carousel>
              </ul>

            </ng-container>

          </div>

        </li>
      </ng-container>
    </ul>
  </div>
</section>
<section class="faq-section">
  <div class="container">
    <h2>
      Frequently Asked Questions
    </h2>
    <ul class="faq-list">
      <li class="accordian" (click)="accordianChange(0)">
        <h3>What’s included in the subscriptions?
          <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
          <p>All of our subscription levels include access to the travel and shopping experiences. With the virtual
            classes, you’ll enjoy a variety of on-demand courses and live trainings that are part of your subscription.
            However, there may be virtual retreats, or series of courses offered for an additional fee, which is
            determined by each instructor or resort. Remember that many of our specialists and experts are small
            business owners, so their expertise is also their livelihood.
          </p>
        </div>
      </li>
      <li class="accordian" (click)="accordianChange(1)">
        <h3>What’s the difference in the membership levels?
          <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
          <p>We believe in flexibility and convenience.
          </p>
          <p>It really comes down to what’s important to you and what you feel you’ll use. If all you want is access to
            the trips and products, you can select the Explorer level at no cost. However, if you would like access to
            the variety of online classes, from nutrition to fitness to yoga to mindfulness and more, then choose the
            Enthusiast level. If doing on-demand videos just won’t do and you also want access to the live classes as
            well as priority access to exclusive promotions and packages, well then consider yourself a Devotee my
            friend!</p>
          <p class="space-less">

            Start there and then add on the Wellness Coach or Wellness Travel Advisor whenever you need more support.
            You can pay monthly if you want to try us out or if you’re ready to commit, choose the annual plan for extra
            savings. Learn more about our subscription plans.</p>
        </div>
      </li>
      <li class="accordian" (click)="accordianChange(2)">
        <h3>Why do I have to set up an account, even if I don’t want a membership?
          <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
          <p>Once you set up your account, you can login to your own page where you can keep track of your purchases,
            your favorites, your playlists and more. We’ll also be able to show you recommendations based on your
            interests for upcoming classes, trips and products so you have a more personalized experience on MyLifeWell.
          </p>

        </div>
      </li>
      <li class="accordian" (click)="accordianChange(3)">
        <h3>If the first 30 days are free, why do I have to enter a credit card?
          <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
          <p>We encourage you to try us out for a full month. If you enjoy your experience on MyLifeWell, we’ll
            automatically bill you after the first 30 days based on the subscription level you selected for your trial.
            If you don’t feel that MyLifeWell is for you, cancel your subscription by the time your trial ends and there
            will be no charges on your card.
          </p>

        </div>
      </li>
      <li class="accordian" (click)="accordianChange(4)">
        <h3>What type of programs are on MyLifeWell?
          <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
          <p>We offer a wide variety of programming to cover the gamut of health and wellness: nutrition, fitness, yoga,
            mindfulness, energy healing, stress management, financial management, anxiety, sleep and more. We’ll
            continue to add programs as we see the need arise.
          </p>

        </div>
      </li>
      <li class="accordian" (click)="accordianChange(5)">
        <h3>Do I need a lot of equipment to work out?
          <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
          <p>It depends on the class you select. There are many classes that use your body weight and no special
            equipment while others suggest having small weights or kettlebells to be the most effective.
          </p>

        </div>
      </li>
      <li class="accordian" (click)="accordianChange(6)">
        <h3>Do I have to be experienced to do the classes?
          <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
          <p>Not at all. Our experts have developed programs that guide you whether it’s your first time or you work out
            all the time. Start with where you’re at and build up from there, you’ll be surprised at how quickly you
            learn and grow.
          </p>

        </div>
      </li>
      <li class="accordian" (click)="accordianChange(7)">
        <h3>I don’t have a lot of time, how long are the classes?
          <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
          <p>Time shouldn’t determine the quality of your experience. We have meditations from 5 minutes to hour long
            fitness and nutrition classes. Start with the time you have and add on when you’re able. It’s not an all or
            none approach, it’s about taking the first step.
          </p>

        </div>
      </li>
      <li class="accordian" (click)="accordianChange(8)">
        <h3>What does a Wellness Coach do?
          <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
          <p>If you don’t know where to start or have a specific health goal in mind, our wellness coaches can help you
            put together a plan based on your needs. They can then recommend the right programs and products, support
            and motivate you on your journey to better health. Learn more about our Wellness Coach package and the
            pre-launch offer.
          </p>

        </div>
      </li>
      <li class="accordian" (click)="accordianChange(9)">
        <h3>What does a Wellness Travel Advisor do?
          <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
          <p>If you need some help finding the right trip, navigating through the Covid restrictions, understanding trip
            insurance (or why you would want it), or customizing the trip for your friends, family or team, you’ll
            benefit from the services of our expert Wellness Travel Advisors. Learn more about our Travel Advisor
            package and the pre-launch offer
          </p>

        </div>
      </li>
    </ul>
  </div>
</section>
<div class="enquiry-poup">
  <app-modal-pop-up [responseMessage]="responseMessage" *ngIf="showAlert" (triggerCloseEvent)="triggerCloseEvent()">
  </app-modal-pop-up>
</div>